import React from 'react';
import { withStyles } from '@material-ui/core';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import { localizeHelpCenterLink } from '../../_config/utils';
import { MOBILE_UDID_STATES } from '../../_config/consts';


const styles = theme => ({
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 10,
  },
  titleText: {
    marginRight: 5,
    marginBottom: 5,
    fontSize: 20,
    fontWeight: 'bold',
    color: '#3f3f3f',
    textAlign: 'left',
  },
  sectionText: {
    margin: 0,
    marginRight: 5,
    fontSize: 16,
    lineHeight: 1.4,
    color: '#3f3f3f',
    textAlign: 'left',
  },
  exampleContainer: {
    marginTop: 15,
    borderRadius: 5,
  },
  exampleText: {
    marginLeft: 12,
    marginTop: 10,
    fontSize: 15,
    color: '#3f3f3f',
    fontWeight: 'bold',
    textAlign: 'center',
  },
});

const GuestDeviceDescriptionView = ({ classes }) => {
  const helpURL = localizeHelpCenterLink('what-is-the-mobile-device-id-what-is-the-purpose-of-removing-device-association');
  return (
    <div style={{ marginLeft: 13, marginBottom: 30 }}>
      <h2 className={classes.titleText}><Entity entity="whatIsIt" /></h2>
      <h2 className={classes.sectionText}><Entity entity="deviceIdDescription" /></h2>
      <h2 className={classes.titleText}><Entity entity="howItWorks" /></h2>
      <h2 className={classes.sectionText}><Entity entity="howItWorksDeviceId" /></h2>
      <h2 className={classes.titleText}><Entity entity="unlimitDeviceUUID" /></h2>
      <h2 className={classes.sectionText}><Entity entity="unlimitDeviceUUIDDescription" /></h2>
      <h2 className={classes.titleText}><Entity entity="mobileUUIDStates" /></h2>
      <div>
        <ul>
          <li><h2 style={{ marginTop: 10 }} className={classes.sectionText}>•<Entity className={classes.sectionText} style={{ fontWeight: 'bold', marginLeft: 5, marginRight: 0 }} entity="deviceUUIDState" data={{ state: MOBILE_UDID_STATES.ALWAYS_VALID }} />: <Entity entity="mobileUUIDAlwaysValidDescription" /></h2></li>
          <li><h2 style={{ marginTop: 10 }} className={classes.sectionText}>•<Entity className={classes.sectionText} style={{ fontWeight: 'bold', marginLeft: 5, marginRight: 0 }} entity="deviceUUIDState" data={{ state: MOBILE_UDID_STATES.SET }} />: <Entity entity="mobileUUIDSetDescription" /></h2></li>
          <li><h2 style={{ marginTop: 10 }} className={classes.sectionText}>•<Entity className={classes.sectionText} style={{ fontWeight: 'bold', marginLeft: 5, marginRight: 0 }} entity="deviceUUIDState" data={{ state: MOBILE_UDID_STATES.NEVER_SET }} />: <Entity entity="mobileUUIDNeverSetDescription" /></h2></li>
          <li><h2 style={{ marginTop: 10 }} className={classes.sectionText}>•<Entity className={classes.sectionText} style={{ fontWeight: 'bold', marginLeft: 5, marginRight: 0 }} entity="deviceUUIDState" data={{ state: MOBILE_UDID_STATES.RESET }} />: <Entity entity="mobileUUIDResetDescription" /></h2></li>
        </ul>
      </div>
      <h5
        className="link-label"
        style={{ margin: 'auto', width: 'fit-content', marginTop: 20, fontSize: 16, textDecoration: 'underline' }}
        onClick={() => window.open(helpURL)}
      >
        <Entity entity="findOutMore" />
      </h5>
    </div>
  );
}
export default withStyles(styles)(GuestDeviceDescriptionView);
